















































































































import axios from 'axios';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoTicketViewer from '@/components/Organisms/co-ticket-viewer/CoTicketViewer.vue';
import { getTicketPurchaseStatusLabelKey } from '@/utils/ticketPurchaseStatus';

interface EventTicket {
    ID?: string;
    Name: string;
    Description?: string;
    PriceInCents: number;
    TaxRateID?: string;
    Limit: number;
    CreatedAt?: number;
    UpdatedAt?: number;
    validUntil?: number;
    CancellationNotice?: number;
    CancellationFee?: number;
    TermsAndConditions?: string;
    AssociatedSessionID?: string;
    PaymentURL: string;
    Status?: number;
}

export default {
    name: 'CoMyTicket',
    components: {
        CoIcon,
        CoCard,
        CoHeadline,
        CoText,
        CoDropdown,
        CoDropdownItem,
        CoRoundButton,
        CoModal,
        CoDate,
        CoTable,
        CoTicketViewer,
    },
    props: {
        tickets: {
            type: Array as () => EventTicket[],
            required: false,
            default: () => [],
        },
        ticket: {
            type: Object as () => EventTicket,
            required: false,
            default: null,
        },
        taxRates: {
            type: Array,
            required: false,
            default: () => [],
        },
        title: {
            type: String,
            required: false,
            default: '',
        },

        myName: {
            type: String,
            required: true,
        },
        eventID: {
            type: String,
            default: null,
        },
        eventName: {
            type: String,
            default: '',
        },
        eventLocationAddress: {
            type: String,
            default: '',
        },
        eventStartDate: {
            type: [String, Number, Date],
            default: null,
        },
        eventEndDate: {
            type: [String, Number, Date],
            default: null,
        },
        currency: {
            type: String,
            default: 'EUR',
        },
        hideContextMenu: {
            type: Boolean,
            default: false,
        },
        isEventPast: {
            type: Boolean,
            default: false,
        },
        hidePurchaseButton: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        iconName() {
            return this.selected ? 'circle-fill' : 'circle';
        },
        classes() {
            return {
                default: true,
                // default: !this.ticket.SoldOut,
                // 'sold-out': this.ticket.SoldOut,
            };
        },

        canTicketBeRefunded() {
            if (!this.eventID || !this.eventStartDate) {
                return false;
            }
            return this.getGroupRefundEligibility(this.normalizedTickets);
        },
        normalizedTickets() {
            if (Array.isArray(this.tickets) && this.tickets.length > 0) {
                return this.tickets;
            }
            if (this.ticket) {
                return [this.ticket];
            }
            return [];
        },
        groupedTickets() {
            const groups = new Map();

            this.normalizedTickets.forEach((ticket, index) => {
                const isGeneral = !ticket?.AssociatedSessionID;
                const sessionKey = ticket?.AssociatedSessionID || `general-${ticket?.ID || index}`;
                if (!groups.has(sessionKey)) {
                    groups.set(sessionKey, {
                        key: sessionKey,
                        isGeneral,
                        createdAt: ticket?.CreatedAt || null,
                        tickets: [],
                    });
                }
                const group = groups.get(sessionKey);
                group.tickets.push(ticket);
                if (!group.createdAt && ticket?.CreatedAt) {
                    group.createdAt = ticket.CreatedAt;
                }
            });

            return Array.from(groups.values())
                .map((group) => ({
                    ...group,
                    canTicketBeRefunded: this.getGroupRefundEligibility(group.tickets),
                }))
                .sort((a, b) => {
                    const aCreatedAt = a.createdAt || 0;
                    const bCreatedAt = b.createdAt || 0;
                    if (aCreatedAt !== bCreatedAt) {
                        return bCreatedAt - aCreatedAt;
                    }
                    return a.key.localeCompare(b.key);
                });
        },
        ticketsTableColumns() {
            return [
                {
                    title: this.$t('labels.ticket'),
                    key: 'Name',
                    notSortable: true,
                },
                {
                    title: this.$t('labels.ticketstatus'),
                    key: 'Status',
                    notSortable: true,
                    style: 'width: 8rem',
                },
                {
                    title: this.$t('labels.ticketcode'),
                    key: 'ID',
                    notSortable: true,
                    style: 'width: 10rem',
                },
            ];
        },
        viewerEventName() {
            if (this.eventName && this.eventName.length > 0) {
                return this.eventName;
            }
            if (this.title && this.title.length > 0) {
                return this.title;
            }
            return this.$t('labels.tickets');
        },
        viewerEventLocation() {
            return typeof this.eventLocationAddress === 'string' ? this.eventLocationAddress : '';
        },
        viewerTaxRate() {
            if (!this.viewerTicket || !this.viewerTicket.TaxRateID) {
                return null;
            }
            const taxRate = (this.taxRates || []).find(
                (rate) => rate.ID === this.viewerTicket.TaxRateID || rate.id === this.viewerTicket.TaxRateID
            );
            if (!taxRate) {
                return null;
            }
            return {
                id: taxRate.ID || taxRate.id || '',
                name: taxRate.Name || taxRate.name || this.$t('labels.vat'),
                percentage: taxRate.Percentage || taxRate.percentage || 0,
                inclusive: Boolean(taxRate.Inclusive ?? taxRate.inclusive),
            };
        },
    },
    watch: {},
    data() {
        return {
            loading: false,
            viewerTicket: null,
            ticketViewerKey: 0,
            activeRefundGroup: null,
        };
    },
    methods: {
        parseEventStartMs() {
            if (!this.eventStartDate) return null;
            if (this.eventStartDate instanceof Date) {
                return this.eventStartDate.getTime();
            }
            const numeric = Number(this.eventStartDate);
            if (!Number.isFinite(numeric)) return null;
            // Treat values as seconds when they look like unix seconds.
            return numeric > 1000000000000 ? numeric : numeric * 1000;
        },
        getGroupRefundEligibility(tickets) {
            if (!this.eventID || !this.eventStartDate) return false;
            if (!Array.isArray(tickets) || tickets.length === 0) return false;
            if (!tickets.every((ticket) => ticket?.Status === 2)) return false;

            const notices = tickets
                .map((ticket) => ticket?.CancellationNotice)
                .filter((value) => typeof value === 'number' && Number.isFinite(value));

            // Favor event organizer: use the strictest (largest) cancellation notice window.
            const strictestNotice = notices.length > 0 ? Math.max(...notices) : null;

            if (strictestNotice == null) {
                return true;
            }

            const eventStartMs = this.parseEventStartMs();
            if (!eventStartMs) return false;

            const nowMs = Date.now();
            const diffMs = eventStartMs - nowMs;
            const days = diffMs / (1000 * 60 * 60 * 24);

            if (days < 0) {
                return false;
            }

            return days >= strictestNotice;
        },
        normalizeTicketForViewer(ticket) {
            if (!ticket) return null;
            const priceInCents = Number.isFinite(ticket.PriceInCents) ? ticket.PriceInCents : 0;
            return {
                ...ticket,
                PriceInCents: priceInCents,
            };
        },
        viewTicketsTable() {
            this.$refs.ticketstable.show();
            this.$emit('viewtickets', this.normalizedTickets);
        },
        openTicketViewer(index, ticket) {
            const normalized = this.normalizeTicketForViewer(ticket);
            if (!normalized) return;
            this.viewerTicket = normalized;
            this.ticketViewerKey += 1;
        },
        purchaseMoreTickets() {
            if (this.isEventPast) {
                return;
            }
            this.$emit('purchasemoretickets');
        },
        showRefundModal(group = null) {
            this.activeRefundGroup = group;
            this.$refs.refundmodal.show();
        },
        hideRefundModal() {
            this.activeRefundGroup = null;
            this.$refs.refundmodal.hide();
        },
        toInvoices() {
            this.$router.push('/account/billing/invoices');
        },
        // refund ticket
        refundTicket() {
            if (!this.getGroupRefundEligibility(this.activeRefundGroup?.tickets)) {
                return;
            }
            this.loading = true;

            // first paid ticket in the group and first ticket if all are free
            let ticketIdToRefund = this.activeRefundGroup?.tickets?.[0]?.ID || '';

            const firstPaidTicket = this.activeRefundGroup?.tickets?.find((ticket) => ticket?.PriceInCents > 0);
            ticketIdToRefund = firstPaidTicket?.ID || ticketIdToRefund;

            const req = {
                ticket_id: ticketIdToRefund,
                event_id: this.eventID,
            };

            axios
                .post(`/event/ticket/refund`, req)
                .then(() => {
                    this.$emit('refunded');

                    this.$refs.refundmodal.hide();
                    this.$refs.ticketstable.hide();
                })
                .catch((error) => {
                    console.error(error);
                    this.$emit('refundfailed');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        ticketStatusLabel(status) {
            return this.$t(getTicketPurchaseStatusLabelKey(status));
        },
    },
};
